export default {"src":"/_next/static/media/Airplane.5653c117.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};